import {
    Card,
    Flex,
    HStack,
    Stack,
    Text,
    Tooltip,
    IconButton,
    Avatar,
    Checkbox,
    useColorModeValue,
} from "@chakra-ui/react";
import { MdCheck, MdReplay } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { Icon } from "@chakra-ui/icons";

export function RowCardMobile({ row, index, onRowClick, user, hasPermission, truncatedColumns, noOfLines }) {
    const bg = index % 2 === 0
        ? useColorModeValue("gray.50", "gray.700")
        : useColorModeValue("white", "gray.800");

    const handleClick = onRowClick ? () => onRowClick(row.original) : undefined;

    return (
        <Card
            key={row.id}
            bg={bg}
            p={4}
            mb={4}
            borderRadius="md"
            shadow="sm"
            cursor={onRowClick ? "pointer" : "default"}
            onDoubleClick={handleClick}
            _hover={{
                bg: useColorModeValue("gray.100", "gray.600"),
            }}
        >
            <Stack spacing={3}>
                {row.cells.map((cell, idx) => {
                    let data = "";

                    if (cell.column.Header === "STATUS") {
                        data = (
                            <Flex align="center" justify="space-between">
                                <Flex
                                    justify="flex-end"
                                    align="center"
                                    border="1px solid"
                                    borderColor={
                                        cell.value === "Paid"
                                            ? "green.400"
                                            : cell.value === "Refunded"
                                                ? "gray.400"
                                                : "red.400"
                                    }
                                    borderRadius="50%"
                                    w="24px"
                                    h="24px"
                                    me="6px"
                                >
                                    <Icon
                                        as={
                                            cell.value === "Paid"
                                                ? MdCheck
                                                : cell.value === "Refunded"
                                                    ? MdReplay
                                                    : IoMdClose
                                        }
                                        color={
                                            cell.value === "Paid"
                                                ? "green.400"
                                                : cell.value === "Refunded"
                                                    ? "gray.400"
                                                    : "red.400"
                                        }
                                        w="20px"
                                        h="20px"
                                    />
                                </Flex>
                                <Text>{cell.value}</Text>
                            </Flex>
                        );
                    } else if (cell.column.Header === "ID") {
                        data = (
                            <Flex align="center" justify="space-between">
                                <Checkbox size="lg" colorScheme="blue" me="8px" />
                                <Text>{cell.value}</Text>
                            </Flex>
                        );
                    } else if (cell.column.Header === "DATE") {
                        data = <Text textAlign="right">{cell.value}</Text>;
                    } else if (cell.column.Header === "CUSTOMER") {
                        data = (
                            <Flex align="center" justify="space-between">
                                <Avatar
                                    name={cell.value.split(" ").join()[0]}
                                    w="30px"
                                    h="30px"
                                    me="6px"
                                />
                                <Text>{cell.value}</Text>
                            </Flex>
                        );
                    } else if (cell.column.Header === "PRODUCT") {
                        data = <Text>{cell.value}</Text>;
                    } else if (cell.column.Header === "REVENUE") {
                        data = <Text>{cell.value}</Text>;
                    } else if (cell.column.actions?.length) {
                        const permittedActions = cell.column.actions.filter((action) => {
                            const perms = Array.isArray(action.permissions)
                                ? action.permissions
                                : action.permissions
                                    ? [action.permissions]
                                    : [];

                            if (
                                perms.length > 0 &&
                                !hasPermission({
                                    userPermissions: user?.profilesPermissions,
                                    requiredPermissions: perms,
                                })
                            ) {
                                return false;
                            }

                            if (typeof action.visible === "boolean") {
                                return action.visible;
                            }
                            if (typeof action.visible === "function") {
                                return action.visible(cell.row.original);
                            }

                            return true;
                        });

                        if (permittedActions.length > 0) {
                            data = (
                                <HStack>
                                    {permittedActions.map((action, idx) => (
                                        <Tooltip key={idx} label={action.label} hasArrow>
                                            <IconButton
                                                aria-label={action.label}
                                                icon={action.icon}
                                                onClick={() => action.onClick(cell.row)}
                                                colorScheme={action.colorScheme}
                                                border={`solid 0.1em ${useColorModeValue(
                                                    "#718096",
                                                    "#4A5568"
                                                )}`}
                                                w="40px"
                                                h="35px"
                                                m="2px"
                                                p={action.p}
                                            />
                                        </Tooltip>
                                    ))}
                                </HStack>
                            );
                        }
                    } else if (cell.column.custom) {
                        data = cell.column.custom(cell);
                    } else if (typeof truncatedColumns !== "undefined") {
                        if (truncatedColumns.includes(cell.column.Header)) {
                            data = (
                                <Tooltip label={cell.value} hasArrow>
                                    <Text noOfLines={noOfLines}>{cell.value}</Text>
                                </Tooltip>
                            );
                        } else {
                            data = <Text>{cell.value}</Text>;
                        }
                    }

                    return (
                        <Flex
                            key={idx}
                            direction="row"
                            align="center"
                            justify="space-between"
                        >
                            <Text fontWeight="semibold">{cell.column.Header}</Text>
                            <Text textAlign="right">{data || cell?.render("Cell")}</Text>
                        </Flex>
                    );
                })}
            </Stack>
        </Card>
    );
}
